import logo from "../img/logo.png";
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import chat_image from "../img/chat2.png";

export default function NavBar(props) {
  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="navbar containment">
        <div>
          <a href={`https://www.scuolaguidalugano.ch/`} className={props.page === 'home' ? 'activeblue' : null}>
            home
          </a>
          <a href={`https://www.scuolaguidalugano.ch/corsi-soccorritori`} className={props.page === 'soccorritori' ? 'activeblue' : null}>
            soccorritori
          </a>
          <a href={`https://www.scuolaguidalugano.ch/sensibilizzazione`} className={props.page === 'sensibilizzazione' ? 'activeblue' : null}>
            sensibilizzazione
          </a>
          <a href={`https://www.scuolaguidalugano.ch/lezioni`} className={props.page === 'lezioni' ? 'activeblue' : null}>
            lezioni guida
          </a>
          <a href={`https://www.scuolaguidalugano.ch/teorico`} className={props.page === 'teorico' ? 'activeblue' : null}>
            Esame teorico
          </a>
          <a href={`https://www.scuolaguidalugano.ch/pratico`} className={props.page === 'pratico' ? 'activeblue' : null}>
            Esame pratico
          </a>
          <a href={`https://www.scuolaguidalugano.ch/moto`} className={props.page === 'moto' ? 'activeblue' : null}>
            corsi moto
          </a>
          <div style={{ display: 'inline-block' }}>
            <Button
              variant="contained"
              className={'whatsapp'}
              size="large"
              style={{ marginRight: '0 !important'}}
              onClick={handleOpenModal}
            >
              <img
                style={{ maxWidth: '24px', marginRight: '10px'}}
                src={chat_image}
                alt={'chat'}
              />
              Contattaci
            </Button>
          </div>
          <a style={{fontFamily: 'Open Sans', fontSize: '20px'}}>
            +41 77 444 29 99 (Sasha) / +41 76 559 91 12 (Dejan)
          </a>
        </div>
      </div>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
        style={{ zIndex: 9999 }}
        PaperProps={{
          style: {
            backgroundColor: '#3a3a3a',
            color: 'white',
            margin: '16px',
            width: 'calc(100% - 32px)',
            maxWidth: '400px'
          }
        }}
      >
        <DialogTitle style={{ textAlign: 'center', fontSize: '24px', paddingBottom: '10px' }}>
          Scegli un contatto
        </DialogTitle>
        <DialogContent style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px', overflow: 'hidden' }}>
          <a
            href={'https://wa.me/+41774442999'}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', width: '100%' }}
          >
            <Button
              variant="contained"
              className={'whatsapp'}
              size="large"
              style={{
                justifyContent: 'flex-start',
                padding: '15px',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <img
                style={{ maxWidth: '24px', marginRight: '10px', flexShrink: 0 }}
                src={chat_image}
                alt={'chat'}
              />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                +41 77 444 29 99 (Sasha)
              </span>
            </Button>
          </a>
          <a
            href={'https://wa.me/+41765599112'}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', width: '100%' }}
          >
            <Button
              variant="contained"
              className={'whatsapp'}
              size="large"
              style={{
                justifyContent: 'flex-start',
                padding: '15px',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <img
                style={{ maxWidth: '24px', marginRight: '10px', flexShrink: 0 }}
                src={chat_image}
                alt={'chat'}
              />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                +41 76 559 91 12 (Dejan)
              </span>
            </Button>
          </a>
        </DialogContent>
      </Dialog>
    </>
  )
}

